import { render, staticRenderFns } from "./PowerCurve.vue?vue&type=template&id=7128b302&scoped=true&"
import script from "./PowerCurve.vue?vue&type=script&lang=js&"
export * from "./PowerCurve.vue?vue&type=script&lang=js&"
import style0 from "./PowerCurve.vue?vue&type=style&index=0&id=7128b302&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128b302",
  null
  
)

export default component.exports